import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import cn from 'classnames';
import Icon from 'components/icon';
import HeadingCropper from 'components/heading-cropper';
import TextSkeleton from 'components/text-skeleton';
import RecipeDetails, {
  sizes as recipeDetailsSizes,
} from 'components/recipe-details';
import { imageSourceBreakpoints } from 'js/breakpoints';

const RecipeTeaser = ({
  className,
  image,
  heading,
  headingTagLevel = 3,
  url,
  recipeDetails,
  preloadImage,
  asSkeleton,
}) => {
  const HeadingTag = `h${headingTagLevel}`;
  return (
    <a href={url} className={cn('recipe-teaser', className)}>
      <div
        className={cn('recipe-teaser__image-container', {
          'recipe-teaser__image-container_no-image': !image,
        })}
      >
        {image && (
          <Image
            {...image}
            sources={[
              {
                width: 391,
                height: 235,
                media: imageSourceBreakpoints.xs,
              },
              {
                width: 344,
                height: 207,
                media: imageSourceBreakpoints.s,
              },
              {
                width: 302,
                height: 222,
                media: imageSourceBreakpoints.m,
              },
              {
                width: 380,
                height: 280,
                media: imageSourceBreakpoints.l,
              },
            ]}
            {...(!preloadImage && { loading: 'lazy' })}
            {...(preloadImage && { fetchPriority: 'high' })}
            className="recipe-teaser__image image_size_recipe-teaser"
          />
        )}
      </div>
      <div className="recipe-teaser__heading-holder">
        {asSkeleton ? (
          <TextSkeleton
            className="recipe-teaser__heading-skeleton"
            lineClassName="recipe-teaser__heading-skeleton-line"
            maxLines={3}
          />
        ) : (
          heading && (
            <HeadingTag className="recipe-teaser__heading">
              <HeadingCropper
                text={heading}
                maxLinesMobile={3}
                maxLinesDesktop={3}
              />
            </HeadingTag>
          )
        )}
      </div>
      <Icon className="recipe-teaser__icon" name="arrow-right-large" />
      {recipeDetails && (
        <RecipeDetails
          {...recipeDetails}
          size={recipeDetailsSizes.small}
          className="recipe-teaser__details"
          useFocusableDetails={false}
        />
      )}
    </a>
  );
};

RecipeTeaser.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  image: PropTypes.exact(Image.propTypes),
  heading: PropTypes.string,
  headingTagLevel: PropTypes.oneOf([2, 3]),
  url: PropTypes.string,
  preloadImage: PropTypes.bool,
  asSkeleton: PropTypes.bool,
  recipeDetails: PropTypes.exact(RecipeDetails.propTypes),
};

RecipeTeaser.viewModelMeta = {
  className: 'ignore',
  headingTagLevel: 'ignore',
  preloadImage: 'ignore',
  asSkeleton: 'ignore',
};

export default RecipeTeaser;
